import type { PostLoginRedirect } from 'types/store';

export const POST_LOGIN_REDIRECT_MAX_AGE_MS = 5 * 60 * 1000;

const AUTHENTICATION_PATHS = new Set([
  '/login',
  '/login-external',
  '/shared',
  '/auth/callback',
  // TODO: F20-3137 Remove /googleoauth2 and /microsoftoauth2 after Keycloak cutover.
  '/microsoftoauth2',
  '/googleoauth2',
  '/google-mapping-redirect',
  '/microsoft-mapping-redirect',
]);

const normalizePathname = (pathname: string): string => pathname.replace(/\/+$/, '') || '/';

const isAllowedPostLoginPath = (url: URL, origin: string): boolean => {
  const pathname = normalizePathname(url.pathname);

  return url.origin === origin && pathname !== '/' && !AUTHENTICATION_PATHS.has(pathname);
};

export const createPostLoginRedirect = (url: string, origin: string, createdAt = Date.now()): PostLoginRedirect | null => {
  try {
    const parsedUrl = new URL(url);

    if (!isAllowedPostLoginPath(parsedUrl, origin)) {
      return null;
    }

    return {
      path: `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`,
      createdAt,
    };
  } catch {
    return null;
  }
};

export const getPostLoginRedirectPath = (redirect: PostLoginRedirect | null, origin: string, now = Date.now()): string | null => {
  if (!redirect || typeof redirect.path !== 'string' || !Number.isFinite(redirect.createdAt) || redirect.createdAt > now) {
    return null;
  }

  if (now - redirect.createdAt >= POST_LOGIN_REDIRECT_MAX_AGE_MS) {
    return null;
  }

  try {
    const parsedUrl = new URL(redirect.path, origin);

    return isAllowedPostLoginPath(parsedUrl, origin) ? `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}` : null;
  } catch {
    return null;
  }
};
